import {ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef} from '@angular/core';
import {CoverImageComponent, MinimalCatalogRecord as MinimalCatalogRecordForCoverImage} from '@aviary/components/cover-image/cover-image.component';
import {NgTemplateOutlet} from '@angular/common';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';

export type MinimalCatalogRecord<ExtraDataType = unknown> = MinimalCatalogRecordForCoverImage & {
  id: number;
  extraData?: ExtraDataType;
};

@Component({
  selector: 'px-cover-image-grid',
  host: {
    class: 'flex flex-row flex-wrap gap-7'
  },
  template: `
    @if ({
      isMdOrAbove: viewportSelectors.isMdAndUp | select
    }; as vm) {
      @for (catalogRecord of catalogRecords; track catalogRecord.id) {
        <div class="flex flex-col gap-3 w-[6.5rem] md:w-[9rem] max-w-[9rem] relative">
          <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
            <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="vm.isMdOrAbove ? 8.75 : 6.25" [heightRem]="8.75" [xPaddingRem]="0.625" [yPaddingRem]="0"
                            yAlignment="BOTTOM"/>
          </a>
          <ng-container *ngTemplateOutlet="catalogRecordInfoTemplate; context: { catalogRecord: catalogRecord, extraData: catalogRecord.extraData }"/>
        </div>
      } @empty {
        @if (noCatalogRecordsTemplate) {
          <ng-container *ngTemplateOutlet="noCatalogRecordsTemplate"/>
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoverImageComponent, NgTemplateOutlet, NamedRouterLinkDirective, SelectPipe]
})
export class CoverImageGridComponent {

  @Input() catalogRecords: MinimalCatalogRecord[] = [];

  @ContentChild('catalogRecordInfo', {read: TemplateRef}) catalogRecordInfoTemplate: TemplateRef<unknown>;
  @ContentChild('noCatalogRecords', {read: TemplateRef}) noCatalogRecordsTemplate?: TemplateRef<unknown>;
  public readonly viewportSelectors = ViewportSelectors;
}
